import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { formatARS, price, totalValue } from '../data/offer';
export function Pricing() {
  return <section id="checkout" className="border-b border-ink-800 bg-ink-900" data-id="element-93" data-mp="2ohnzw6dhv8mm">
      <div className="mx-auto max-w-3xl px-5 py-16 sm:py-20" data-id="element-94" data-mp="2jj4c00fcbmrm">
        <p className="mb-4 text-xs font-semibold uppercase tracking-[0.22em] text-flame-500" data-id="element-95" data-mp="2jlyu3lavsvhv">
          Precio y cierre
        </p>
        <h2 className="font-display text-4xl font-extrabold uppercase leading-none text-white sm:text-5xl" data-id="element-96" data-mp="1rsyew76klzwf">
          No vas a pagar {formatARS(totalValue)}
        </h2>
        <p className="mt-6 text-lg leading-relaxed text-zinc-400" data-id="element-97" data-mp="25pv5c7is1fcs">
          Ni siquiera vas a pagar lo que cuesta una cuota mensual de un box de CrossFit o
          un Personal Trainer. Hoy podés llevarte el sistema completo que transformará tu
          rendimiento para siempre por un pago único de:
        </p>

        <motion.div className="mt-10 rounded-2xl border-2 border-flame-500 bg-ink-950 p-7 text-center sm:p-10" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.4
      }} transition={{
        duration: 0.5,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-98" data-mp="3vzp5xj5hic9j">
          <p className="inline-flex items-center gap-2 rounded-full bg-flame-500 px-3 py-1 text-xs font-bold uppercase tracking-[0.18em] text-white" data-id="element-99" data-mp="eqa7xd7lt5fd">
            <ZapIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-100" data-mp="3i81x6jucvb9v" />
            70% OFF · 48 horas
          </p>

          <p className="mt-6 font-display text-2xl font-bold text-zinc-500 line-through tabular-nums" data-id="element-101" data-mp="3n7ew42yi48st">
            {formatARS(totalValue)} ARS
          </p>
          <p className="font-display text-7xl font-extrabold leading-none tabular-nums text-white sm:text-8xl" data-id="element-102" data-mp="3rz6brig4cu46">
            {formatARS(price)}
          </p>
          <p className="mt-2 font-display text-xl font-bold uppercase tracking-[0.2em] text-flame-500" data-id="element-103" data-mp="2zh13obc087xp">
            ARS · Pago único
          </p>

          <div className="mt-9" data-id="element-104" data-mp="2rf1v64amxm8d">
            <CTAButton data-id="element-105" data-mp="2mi1l7ianzzbz" />
          </div>
          <p className="mt-4 text-sm text-zinc-500" data-id="element-106" data-mp="2mh08zahwx6so">
            Acceso inmediato a la guía, al plan de 12 semanas y a los 5 bonos.
          </p>
        </motion.div>
      </div>
    </section>;
}